import { createAction } from '../../../core/helpers'

import { COMMON_FETCH_INGREDIENTS } from '../action-types'

const cleanupCommonFetchIngredients = createAction(
  COMMON_FETCH_INGREDIENTS.CLEANUP,
)

export default cleanupCommonFetchIngredients
